"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageSchema = exports.userSchema = exports.documentsTransformer = void 0;
const zod_1 = require("zod");
const json_1 = require("../commonUtils/json");
exports.documentsTransformer = zod_1.z.preprocess((docs) => {
    if (typeof docs === 'string') {
        return (0, json_1.tryParseJSON)(docs, []);
    }
    if (!docs || !Array.isArray(docs))
        return docs;
    return docs
        .map((doc) => {
        // If it's already a string URL, return it as is
        if (typeof doc === 'string')
            return doc;
        // If it's an object with a url property, extract the URL
        if (doc && typeof doc === 'object' && doc.url)
            return doc.url;
        // If it's something else, return null (will be filtered out)
        return null;
    })
        .filter(Boolean); // Remove null values
}, zod_1.z.array(zod_1.z.string()).optional());
exports.userSchema = zod_1.z.object({
    option: zod_1.z.number().or(zod_1.z.string()),
    type: zod_1.z.string(),
});
exports.imageSchema = zod_1.z.object({
    url: zod_1.z.string(),
});
